export enum MultivariateBehaviourType {
    NotSpecified = 0,
    Same = 1,
    Randomise = 2
}
